import { render, staticRenderFns } from "./SupplierQuality.vue?vue&type=template&id=348fdab8&scoped=true&lang=true&"
import script from "./SupplierQuality.vue?vue&type=script&lang=js&"
export * from "./SupplierQuality.vue?vue&type=script&lang=js&"
import style0 from "./SupplierQuality.vue?vue&type=style&index=0&id=348fdab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348fdab8",
  null
  
)

export default component.exports